import { MARKER_LOCATION_DEFAULT_SIZE } from "./marker-location.constant";

export const scaleMarkerLocationSize = (scale: number = 1) => ({
  width: MARKER_LOCATION_DEFAULT_SIZE.width * scale,
  height: MARKER_LOCATION_DEFAULT_SIZE.height * scale,
});
